import { sendWebsocketMessage } from '../../../../../App';
/**
 * I cant remember what goes in this object honestly... I think its like the datasource, watchlistName, and symbol, but ya, cant say for sure...s
 * @param {} data
 */
export function addSymbol(data) {
  if (data.symbol) {
    const message = {
      messageType: 'addSymbol',
      addSymbol: data,
    };
    sendWebsocketMessage(message);
  }
}

/*
data = {
  symbolL: amd,
  dataSource: 'LIVE',
  watchlist_name: moduleId
}

*/
